import { useEffect, useLayoutEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useStore } from '@ui/hooks/useStore';
import { useParams } from '@ui/hooks/useParams';
import { usePage } from '@ui/hooks/usePage';

export const useRoutes = () => {
    const { user, app, devices, groups, lang } = useStore();
    const navigate = useNavigate();
    const location = useLocation();
    const page = usePage();
    useParams();

    const authPath = '/auth';
    const smsPath = '/sms/';
    useLayoutEffect(() => {
        app.setPage(page);
    }, [page]);
    useLayoutEffect(() => {
        app.setSearch(location.search);
    }, [location.search]);
    useEffect(() => {
        const path = location.pathname;
        if (user.token) {
            user.getSettings();
            groups.getUserGroups();
        }
        if (!user.token) {
            localStorage.removeItem('userLogin');
            localStorage.removeItem('userType');
            localStorage.removeItem('groupId');
            app.resetDemoMode();
            user.setDefault();
            if (!user.token && smsPath === path) {
                navigate(smsPath);
            }
            else {
                navigate(authPath);
            }
        }
        // if (!user.token && authPath !== path) {
        //     navigate(authPath);
        // }
        if (user.token && authPath === path) {
            navigate('/');
        }
    }, [user.token]);

    return { user, devices, lang };
};
